import i18next from "i18next";

import { getToken } from "../../utils/OktaHelpers";
import { getUserAttributeObj } from "../../utils/UserHelper";

const HTTP_HEADER_VALUES = Object.freeze({
    skip: "skip",
});

const HTTP_HEADERS = Object.freeze({
    authorization: "Authorization",
    neospectraLanguage: "neospectra-language",
    neospectraId: "neospectra-organization-id",
});

const HTTP_PREDEFINED_HEADERS = Object.freeze({
    skipLanguage: {
        [HTTP_HEADERS.neospectraLanguage]: HTTP_HEADER_VALUES.skip,
    },
});

const handleRequestHeaders = (request) => {
    const organizationId = getUserAttributeObj("organization")?.id;

    request.headers[HTTP_HEADERS.authorization] = "bearer " + getToken();

    if (
        request.headers[HTTP_HEADERS.neospectraLanguage] !=
        HTTP_HEADER_VALUES.skip
    )
        request.headers[HTTP_HEADERS.neospectraLanguage] = i18next.language;

    if (organizationId)
        request.headers[HTTP_HEADERS.neospectraId] = organizationId;

    return request;
};

export {
    handleRequestHeaders,
    HTTP_HEADERS,
    HTTP_HEADER_VALUES,
    HTTP_PREDEFINED_HEADERS,
};
